import Vue from "vue";
import VueRouter from "vue-router";
import {formatMessage} from "@/locale"
import { getToken } from "@/utils/index";

Vue.use(VueRouter);

// 开发环境不使用懒加载, 因为懒加载页面太多的话会造成webpack热更新太慢, 所以只有生产环境使用懒加载
const _import = require('./import-' + process.env.NODE_ENV);

// 全局路由(无需嵌套上左右整体布局)
const globalRoutes = [
  { path: '/404', component: _import('error/404'), name: '404', meta: { title: formatMessage({id:"message.title.404"}) } },
  { path: '/403', component: _import('error/403'), name: '403', meta: { title: formatMessage({id:"message.title.403"}) } },
  { path: '/login', component: _import('common/login'), name: 'login', meta: { title: formatMessage({id:"message.title.timeout"}) } },

];

// 主入口路由
const mainRoutes = {
  path: '/',
  component: _import('main'),
  name: 'main',
  redirect: { name: 'home' },
  meta: { title: formatMessage({id:"message.title.home"}) },
  children: [
    { path: '/home', component: _import('home'), name: 'home', meta: { title: "公积金智库", keepAlive: true } },
    { path: '/fund/account/query/:cityId', component: _import('fund/account/query'), name: 'fundquery', meta: { title: "账户查询" }},
    { path: '/fund/faq/list/:cityId', component: _import('fund/faq/list'), name: 'fundfaqlist', meta: { title: "常见问题", keepAlive: true}},
    { path: '/fund/faq/detail/:id', component: _import('fund/faq/detail'), name: 'fundfaqdetail', meta: { title: "详情" }},
    { path: '/fund/faq/search/:cityId', component: _import('fund/faq/search'), name: 'fundfaqsearch', meta: { title: "搜索结果" }},
    { path: '/fund/forum/list/:cityId', component: _import('fund/forum/list'), name: 'fundForumList', meta: { title: "智库问答", keepAlive: true}},
    { path: '/fund/forum/answer/:topicId', component: _import('fund/forum/answer'), name: 'fundForumAnswer', meta: { title: "详情"}},
    { path: '/fund/forum/createtopic/:cityId/:type', component: _import('fund/forum/createtopic'), name: 'fundForumCreateTopic', meta: { title: "我要提问"}},
    { path: '/fund/zdyw/list/:cityId', component: _import('fund/zdyw/list'), name: 'fundZdywList', meta: { title: "重点业务"}},
    { path: '/fund/news/detail', component: _import('fund/news/detail'), name: 'newsDetail', meta: { title: "详情"}},
  ]
};

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: (to, from, savedPosition) => ({ x: 0, y: 0 }),
  routes: globalRoutes.concat(mainRoutes)
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  next();
});

export default router;
